module.exports = __webpack_public_path__ + "/img/SON-Labeled-NwjH6Z.svg";